<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed, onMounted, ref } from "vue";
import { ServiceDisplayState } from "@/shared/@types/ServiceDisplayState";
import type { PictogramName } from "@/shared/@types/PictogramName";
import { isAuthenticated } from "@/shared/auth/isAuthenticated.helper";
import ServiceCard from "@/shared/components/ServiceCard/ServiceCard.vue";
import Title from "@/shared/components/Title/Title.vue";
import { useAccountStore } from "@/shared/stores/AccountStore";

const { t } = useI18n();
const accountStore = useAccountStore();

const userIsAuthenticated = ref(false);

const services = computed(() => [
  {
    title: t("registration.user.overview.fbsHub.title"),
    pictogram: "fbsHub",
    link: userIsAuthenticated.value
      ? "/fbs-hub/add-customer"
      : "/registration/fbs-hub",
    isExternalLink: false,
    displayState: computed(() => ServiceDisplayState.Enabled),
    previewText: t("registration.user.overview.fbsHub.previewText"),
  },
  {
    title: t("registration.user.overview.mobility.title"),
    pictogram: "compactCard",
    link: `/registration/mobility`,
    isExternalLink: false,
    displayState: computed(() => ServiceDisplayState.Enabled),
    previewText: t("registration.user.overview.mobility.previewText"),
  },
  {
    title: t("registration.user.overview.gasShop.title"),
    pictogram: "gasShop",
    link: userIsAuthenticated.value
      ? "/gas-shop/add-customer"
      : "/registration/gas-shop",
    isExternalLink: false,
    displayState: computed(() => ServiceDisplayState.Enabled),
    previewText: t("registration.user.overview.gasShop.previewText"),
  },
]);

onMounted(async () => {
  userIsAuthenticated.value = await isAuthenticated();
  if (userIsAuthenticated.value) {
    await accountStore.fetchUser();
  }
});
</script>

<template>
  <div class="registration-overview-view">
    <div class="max-width-box stack-layout">
      <Title
        size="l"
        :text="t('registration.user.overview.title')"
      />
      <p>{{ t("registration.user.overview.text") }}</p>
    </div>
    <div class="registration-overview-view--services-grid">
      <ServiceCard
        v-for="service in services"
        :key="service.title"
        :title="service.title"
        :pictogram="service.pictogram as PictogramName"
        :link="service.link"
        :is-external-link="service.isExternalLink"
        :preview-text="service.previewText"
        :display-state="service.displayState.value"
        background-color="gray"
        show-preview-text
      />
    </div>
  </div>
</template>

<style scoped>
@import "RegistrationOverviewView.css";
</style>
